<template>
 <AdminPanelMegogoPackageSelling />
</template>

<script>
import AdminPanelMegogoPackageSelling from '../components/AdminPanelMegogoPackageSelling.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelMegogoPackageSelling
    },
    methods: {},
    mounted() {}
}
</script>
